import { render, staticRenderFns } from "./ModalAddWarehouse.vue?vue&type=template&id=3b58ff95&"
import script from "./ModalAddWarehouse.vue?vue&type=script&lang=js&"
export * from "./ModalAddWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddWarehouse.vue?vue&type=style&index=0&id=3b58ff95&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports